import { render, staticRenderFns } from "./contract-summary2.vue?vue&type=template&id=129a2c66&scoped=true"
import script from "./contract-summary2.vue?vue&type=script&lang=js"
export * from "./contract-summary2.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=129a2c66&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a2c66",
  null
  
)

export default component.exports